<app-header [enableBack]="false">
  <div title>{{ 'actorregister.title' | translate }}</div>
</app-header>

<div class="p-6">
  <app-card>
    <form [formGroup]="form">
      <div class="flex gap-4">
        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'actorregister.search.businessrole' | translate }}</label>
            <select appSelect [autofocus]="true" [collection]="businessRoleList" formControlName="businessRole"></select>
          </app-input-group>
        </div>
        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'actorregister.search.name' | translate }}</label>
            <input type="text" appInput formControlName="name" [placeholder]="'actorregister.search.name' | translate">
          </app-input-group>
        </div>
        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'actorregister.search.identification' | translate }}</label>
            <input appInput inputmode="numeric" pattern="[0-9]*" formControlName="identification" [placeholder]="'actorregister.search.identification' | translate">
          </app-input-group>
        </div>
        <div class="w-1/4"></div>
      </div>
      <div>
        <button appButton (click)="table.search()">{{ 'common.search' | translate }}</button>
      </div>
    </form>
  </app-card>

  <app-table
    #table
    [config]="actorTableConfig"
    [(selectedElements)]="selectedElements"
  >
  </app-table>
</div>
